export default __webpack_public_path__ + "static/media/greekgo-mobile-2.cc7fd050.png";